<div class="background-shopping-page">
    <app-form-data-customer></app-form-data-customer>
</div>
